<div class="table-container">
  <div class="table-header">
    <div class="table-header-label fs-12"><span>List Of Passengers</span></div>
    <div *ngIf="whatsappComm" class="displayFlex align-item-center   watsappComm">
      <mis-checkbox  [type]="'Default'" [checked]="false"  (valueChange)="onWhatsappCheck($event)"  [name]="'whatsapp'" [checked]="whatsappCommunication"
              ></mis-checkbox>
      <span class="ml-8 fs-12 displayFlex align-item-center">Receive trip details on <img src="assets/Digital_Inline_Dark_Green 1.svg" alt="" class="ml-4"> </span>
    </div>
    <div class="search-wrapper">
    </div>
  </div>
  <div class="table-content">
  <table border="0" cellspacing="0" cellpadding="0" *ngIf="!enableAlternateMobileNumber">
    <thead class="rider-table-header">
      <tr>
        <th class="column-heading">#</th>
        <ng-container *ngFor="let field of formConfig">
          <th class="column-heading" *ngIf="field.elementKey !== 'payer' && isTableCellVisible(field) && !['alternatePhoneCode','alternateMobile'].includes(field.elementKey)">
            {{field.config.displayName}} <span *ngIf="field.config.mandatory" class="mandatoryField">*</span></th>
          <th class="column-heading" *ngIf="field.elementKey === 'payer' 
            && field.config.visibility.visible
            && paymentType === 'Bill To User'
            && isTableCellVisible(field)">{{field.config.displayName}}</th>
        </ng-container>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </thead>

    <tbody>
      <!-- rider row -->
      <tr *ngFor="let rider of formArray.controls; let i = index;" class="rider-row-container"
        [ngClass]="rider.controls.riderType?.value==='MARSHAL'?'disabled':''">

        <!-- rider standard view -->
        <ng-container *ngIf="!riderStateArray[i]?.isEditActive">
          <td (mouseover)="onEditClick(i)">{{i+1}}</td>
          <ng-container *ngFor="let field of formConfig">
            <td *ngIf="isTableCellVisible(field) && !['payer','alternatePhoneCode','alternateMobile'].includes(field.elementKey)">
              {{ ['mobile'].includes(field.elementKey) ? (rider.get(field.elementKey)?.value | formatPhoneNumber : rider.value):  rider.get(field.elementKey)?.value }}
            </td>
            <td *ngIf="field.elementKey === 'payer' 
              && field.config.visibility.visible
              && paymentType === 'Bill To User'" class="editable-row-static-content">
              <app-radio-button *ngIf="payeeOptions[i]?.payerType !== 'Guest'" class="option-radio"
                [option]="payeeOptions[i]" [selectedValue]="selectedPayer" (changeCallback)="onRiderChange($event)"
                name="payerSelect">
              </app-radio-button>
              
            </td>
          </ng-container>
          <td><button mat-icon-button (click)="onEditClick(i)" class="edit-rider-btn">
            <mat-icon>edit</mat-icon>
          </button></td>
          <td class="editable-row-button rider-row-default">
         <button mat-icon-button *ngIf="rider.get('isNew') || !editModeControlHide['ClearRiderRow']"
              (click)="onDeleteClick(i)"  [ngClass]="{'disableDropdown': commonService.workflowConfig?.blockSelfDeletion && rider.get('riderType').value=='Self' }">
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- rider editable view -->
        <ng-container *ngIf="riderStateArray[i]?.isEditActive">
       <td class="editable-row-static-content">{{i+1}}</td>
         <ng-container *ngFor="let field of formConfig">
            <ng-container *ngIf="isTableCellVisible(field)">

              <td class="editable-cells"
                *ngIf="!editRiderInfo && !rider.get(field.elementKey).disabled && !['payer','alternateMobile','alternatePhoneCode'].includes(field.elementKey)">
                <ng-container *ngIf="checkVisibility(field.config, rider)">
                  <app-field-generator
                    *ngIf="!['costCenter','riderType','phoneCode','payer','department','businessUnit'].includes(field.elementKey)"
                    [config]="field.config" [inputControl]="rider.get(field.elementKey)"
                    [etsMandate]="field.elementKey === 'mobile' && phoneNumberInEtsMandatory[i]"
                    [styleApplied]="styleApplied" [elementKey]="field.elementKey">
                  </app-field-generator>
                  
                  <app-select *ngIf="field.elementKey == 'phoneCode'" [showClear]="!field.config.mandatory"
                    [config]="field.config" [type]="formConstants.getElementType(field.config.elementType)"
                    [formControl]="rider.get(field.elementKey)" [getCustomOptionValue]="getPhoneCodeValue"
                    [getCustomOptionLabel]="getPhoneCodeLabel" [options]="phoneCodes" [label]="'+91'"
                    [selectStyleApplied]="selectStyleApplied">
                  </app-select>
                  <div *ngIf="field.elementKey == 'riderType'">
                    <mis-dropdown [data]="riderTypeMapping" [searchEnabled]="false" [label]="selectedRider" height="32px" width="192px"
                    dropdownListHeight="180px" dropdownListWidth="192px" dropdownListPosition="Left" noDataMessage="No Data"
                    (onChange)="onRiderTypeChange(formArray.at(i), riderStateArray[i], $event, i,$event)" >
                    </mis-dropdown>
                  </div>
                  <app-select [showClear]="!field.config.mandatory" *ngIf="field.elementKey == 'costCenter'"
                    [config]="field.config" [type]="'dropdownAndSearch'" [formControl]="rider.get(field.elementKey)"
                    [options]="this.costCenterNames" [selectStyleApplied]="selectStyleApplied" [editableCostCenter]="editableCostCenter" [ngClass]="{'disableDropdown':field.config?.disable &&  rider.get(field.elementKey).value}">
                  </app-select>
                  <app-select [showClear]="!field.config.mandatory" *ngIf="['department','businessUnit'].includes(field.elementKey)"
                    [config]="field.config" [type]="'dropdownAndSearch'" [formControl]="rider.get(field.elementKey)"
                    [options]="this.departmentListName" [selectStyleApplied]="selectStyleApplied" [ngClass]="{'disableDropdown':field.config?.disable &&  rider.get(field.elementKey).value}">
                  </app-select>    
                </ng-container>
              </td>

              <td class="editable-cells" *ngIf="editRiderInfo && !['payer','alternateMobile','alternatePhoneCode'].includes(field.elementKey)">
                <ng-container *ngIf="checkVisibility(field.config, rider)">
                  <app-field-generator
                  [hidden]="rider.get(field.elementKey).isHidden" 
                    *ngIf="!['costCenter','riderType','phoneCode','payer','department','businessUnit'].includes(field.elementKey)"
                    [config]="field.config" [inputControl]="rider.get(field.elementKey)"
                    [etsMandate]="field.elementKey === 'mobile' && phoneNumberInEtsMandatory[i]"
                    [ngClass]="{'disableDropdown':field.elementKey== 'department' && editRiderInfo }"
                    [styleApplied]="styleApplied" [elementKey]="field.elementKey">
                  </app-field-generator>
                  <div  class="mobile-no" *ngIf="field.elementKey =='mobile' && rider.get(field.elementKey).isHidden">
                    {{(rider.get('mobile')?.value | formatPhoneNumber : rider.value)}}
                  </div>
                  <app-select *ngIf="field.elementKey == 'phoneCode'" [showClear]="!field.config.mandatory" 
                    [config]="field.config" [type]="formConstants.getElementType(field.config.elementType)"
                    [formControl]="rider.get(field.elementKey)" [getCustomOptionValue]="getPhoneCodeValue"
                    [getCustomOptionLabel]="getPhoneCodeLabel" [options]="phoneCodes"
                    [selectStyleApplied]="selectStyleApplied" [editRiderPhoneCode]="riderStateArray[i]">
                  </app-select>
                  <div *ngIf="field.elementKey == 'riderType'"  [ngClass]="{'disableDropdown':editRiderInfo }">
                    <mis-dropdown [data]="riderTypeMapping" [searchEnabled]="false" [label]="selectedRider" height="32px" width="192px"
                    dropdownListHeight="180px" dropdownListWidth="192px" dropdownListPosition="Left" noDataMessage="No Data"
                    (onChange)="onRiderTypeChange(formArray.at(i), riderStateArray[i], $event, i,$event)" >
                    </mis-dropdown>
                  </div>
                  <app-select [showClear]="!field.config.mandatory" *ngIf="field.elementKey == 'costCenter'"
                    [config]="field.config" [type]="'dropdownAndSearch'" [formControl]="rider.get(field.elementKey)"
                    [options]="this.costCenterNames" [selectStyleApplied]="selectStyleApplied" [editableCostCenter]="editableCostCenter" [ngClass]="{'disableDropdown':field.config?.disable &&  rider.get(field.elementKey).value}">
                  </app-select>
                  <app-select [showClear]="!field.config.mandatory" *ngIf="['department','businessUnit'].includes(field.elementKey)"
                    [config]="field.config" [type]="'dropdownAndSearch'" [formControl]="rider.get(field.elementKey)"
                    [options]="this.departmentListName" [selectStyleApplied]="selectStyleApplied" [ngClass]="{'disableDropdown':field.config?.disable &&  rider.get(field.elementKey).value}">
                  </app-select>  
                </ng-container>
              </td>

              <td class="editable-row-static-content" [ngClass]="field.elementKey"
                *ngIf="!editRiderInfo && rider.get(field.elementKey).disabled && !['alternateMobile','alternatePhoneCode'].includes(field.elementKey)">
                 {{ ['mobile'].includes(field.elementKey) ? (rider.get(field.elementKey)?.value | formatPhoneNumber : rider.value):  rider.get(field.elementKey)?.value }}
              </td>
              <td class="editable-row-static-content" *ngIf="field.elementKey === 'payer' 
                && field.config.visibility.visible
                && paymentType === 'Bill To User'">
                <app-radio-button *ngIf="rider.get('riderType')?.value !== 'Guest'" class="option-radio"
                  [option]="payeeOptions[i]" [selectedValue]="selectedPayer" (changeCallback)="onRiderChange($event)"
                  name="payerSelect">
                </app-radio-button>
              
              </td>
            </ng-container>
          </ng-container>
          <td><button mat-icon-button (click)="onEditClick(i)" class="edit-rider-btn">
              <mat-icon>edit</mat-icon>
            </button></td>
          <td class="editable-row-button rider-row-default">
       <button mat-icon-button *ngIf="rider.get('isNew') || !editModeControlHide['ClearRiderRow']"
              (click)="onDeleteClick(i,formArray.at(i))"  [ngClass]="{'disableDropdown': commonService.workflowConfig?.blockSelfDeletion && rider.get('riderTypeId').value=='Self' }">
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
  <table border="0" cellspacing="0" cellpadding="0" *ngIf="enableAlternateMobileNumber" class="alternateMobileTable">
    <thead class="rider-table-header">
      <tr>
        <th class="column-heading">#</th>
        <ng-container *ngFor="let field of formConfig">
          <th class="column-heading " [ngClass]="field.elementKey"
            *ngIf="field.elementKey !== 'payer' && isTableCellVisible(field) && field.elementKey !== 'mobile' && field.elementKey !== 'phoneCode'">
            {{field.config.displayName}} <span *ngIf="field.config.mandatory" class="mandatoryField">*</span></th>
          <th class="column-heading" *ngIf="field.elementKey === 'payer' 
            && field.config.visibility.visible
            && paymentType === 'Bill To User'
            && isTableCellVisible(field)">{{field.config.displayName}}</th>
        </ng-container>
        <th></th>
        <th></th>
      </tr>
    </thead>

    <tbody>
      <!-- rider row -->
      <tr *ngFor="let rider of formArray.controls; let i = index;" class="rider-row-container"
        [ngClass]="rider.controls.riderType?.value==='MARSHAL'?'disabled':''">

        <!-- rider standard view -->
        <ng-container *ngIf="!riderStateArray[i]?.isEditActive">
          <td (mouseover)="onEditClick(i)">{{i+1}}</td>
          <ng-container *ngFor="let field of formConfig">
            <td *ngIf="field.elementKey !== 'payer' && isTableCellVisible(field) && !['phoneCode', 'alternatePhoneCode'].includes(field.elementKey)" [ngClass]="field.elementKey" >
              {{ ['mobile'].includes(field.elementKey) ? (rider.get(field.elementKey)?.value | formatPhoneNumber : rider.value):  rider.get(field.elementKey)?.value }}
            </td>
            <td *ngIf="field.elementKey === 'payer'
              && field.config.visibility.visible
              && paymentType === 'Bill To User'" class="editable-row-static-content">
              <app-radio-button *ngIf="payeeOptions[i].payerType !== 'Guest'" class="option-radio"
                [option]="payeeOptions[i]" [selectedValue]="selectedPayer" (changeCallback)="onRiderChange($event)"
                name="payerSelect">
              </app-radio-button>
            </td>
          </ng-container>
          <td><button mat-icon-button (click)="onEditClick(i)" class="edit-rider-btn">
            <mat-icon>edit</mat-icon>
          </button></td>
          <td class="editable-row-button rider-row-default">
            <button mat-icon-button *ngIf="rider.get('isNew') || !editModeControlHide['ClearRiderRow']"
              (click)="onDeleteClick(i)" [ngClass]="{'disableDropdown': commonService.workflowConfig?.blockSelfDeletion && rider.get('riderType').value=='Self' }">
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- rider editable view -->
        <ng-container *ngIf="riderStateArray[i]?.isEditActive">
          <td class="editable-row-static-content" >{{i+1}}</td>
          <ng-container *ngFor="let field of formConfig">
            <ng-container *ngIf="isTableCellVisible(field)">
              <td class="editable-cells"
                *ngIf="!editRiderInfo && !rider.get(field.elementKey).disabled && field.elementKey !== 'payer' &&
                field.elementKey !=='phoneCode' && field.elementKey !=='mobile'"  [ngClass]="field.elementKey">
                
                <ng-container >
                 
                  <app-field-generator
                    *ngIf="!['costCenter','riderType','phoneCode' ,'payer','alternateMobile','alternatePhoneCode','department','businessUnit'].includes(field.elementKey)"
                    [config]="field.config" [inputControl]="rider.get(field.elementKey)"
                    [etsMandate]="field.elementKey === 'mobile' && phoneNumberInEtsMandatory[i]"
                    [styleApplied]="styleApplied" [elementKey]="field.elementKey">
                  </app-field-generator >
                  <app-select *ngIf="field.elementKey == 'phoneCode'" [showClear]="!field.config.mandatory" 
                    [config]="field.config" [type]="formConstants.getElementType(field.config.elementType)"
                    [formControl]="rider.get(field.elementKey)" [getCustomOptionValue]="getPhoneCodeValue"
                    [getCustomOptionLabel]="getPhoneCodeLabel" [options]="phoneCodes"
                    [selectStyleApplied]="selectStyleApplied">
                  </app-select>
                  <div *ngIf="field.elementKey == 'riderType'"  [ngClass]="{'disableDropdown':editRiderInfo }">
                    <mis-dropdown [data]="riderTypeMapping" [searchEnabled]="false" [label]="selectedRider" height="32px" width="192px"
                    dropdownListHeight="180px" dropdownListWidth="192px" dropdownListPosition="Left" noDataMessage="No Data"
                    (onChange)="onRiderTypeChange(formArray.at(i), riderStateArray[i], $event, i,$event)" >
                    </mis-dropdown>
                  </div>
                  <app-select [showClear]="!field.config.mandatory" *ngIf="field.elementKey == 'costCenter'"
                    [config]="field.config" [type]="'dropdownAndSearch'" [formControl]="rider.get(field.elementKey)"
                    [options]="this.costCenterNames" [selectStyleApplied]="selectStyleApplied" [editableCostCenter]="editableCostCenter" [ngClass]="{'disableDropdown':field.config?.disable &&  rider.get(field.elementKey).value}">
                  </app-select>
                  <app-select [showClear]="!field.config.mandatory" *ngIf="['department','businessUnit'].includes(field.elementKey)"
                    [config]="field.config" [type]="'dropdownAndSearch'" [formControl]="rider.get(field.elementKey)"
                    [options]="this.departmentListName" [selectStyleApplied]="selectStyleApplied" [ngClass]="{'disableDropdown':field.config?.disable &&  rider.get(field.elementKey).value}">
                  </app-select>
                    <app-phone-input-component
                    *ngIf="field.elementKey =='alternateMobile'"
                    [hidden]="rider.get(field.elementKey).isHidden"
                    [config]="field.config"
                    [formControls]="rider.get(field.elementKey)"
                    [inputFormControlNumber]="rider.get('mobile')"
                    [inputFormControlCode]="rider.get('phoneCode')"
                    (onCodeChange)="onCodeChange($event,rider.get('phoneCode'))"
                    [dropdownWidth]="'6vw'"
                    >
                    </app-phone-input-component>
                    <div  class="mobile-no" *ngIf="field.elementKey =='alternateMobile' && rider.get(field.elementKey).isHidden">
                      {{rider.get('phoneCode')?.value + " " + (rider.get('mobile')?.value | formatPhoneNumber : rider.value)}}
                    </div>
                    <app-phone-input-component
                    *ngIf="field.elementKey =='alternatePhoneCode'"
                    [config]="field.config"
                    [formControls]="rider.get(field.elementKey)"
                    [inputFormControlNumber]="rider.get('alternateMobile')"
                    [inputFormControlCode]="rider.get('alternatePhoneCode')"
                    (onCodeChange)="onCodeChange($event,rider.get('alternatePhoneCode'))"
                    [dropdownWidth]="'6vw'"
                    >
                      
                    </app-phone-input-component>  
                </ng-container>
              </td>



              <td class="editable-cells"  *ngIf="editRiderInfo && !['payer', 'mobile' ,'phoneCode'].includes(field.elementKey)" [ngClass]="field.elementKey">
                <ng-container >
                  <app-field-generator
                  *ngIf="!['costCenter','riderType','phoneCode', 'payer','alternateMobile','alternatePhoneCode','department','businessUnit'].includes(field.elementKey)"
                    [config]="field.config" [inputControl]="rider.get(field.elementKey)"
                    [etsMandate]="field.elementKey === 'mobile' && phoneNumberInEtsMandatory[i]"
                    [styleApplied]="styleApplied" [elementKey]="field.elementKey">
                  </app-field-generator>
                  <app-select *ngIf="field.elementKey == 'phoneCode'" [showClear]="!field.config.mandatory"
                    [config]="field.config" [type]="formConstants.getElementType(field.config.elementType)"
                    [formControl]="rider.get(field.elementKey)" [getCustomOptionValue]="getPhoneCodeValue"
                    [getCustomOptionLabel]="getPhoneCodeLabel" [options]="phoneCodes"
                    [selectStyleApplied]="selectStyleApplied">
                  </app-select>
                  <div *ngIf="field.elementKey == 'riderType'"  [ngClass]="{'disableDropdown':editRiderInfo }">
                    <mis-dropdown [data]="riderTypeMapping" [searchEnabled]="false" [label]="selectedRider" height="32px" width="192px"
                    dropdownListHeight="180px" dropdownListWidth="192px" dropdownListPosition="Left" noDataMessage="No Data"
                    (onChange)="onRiderTypeChange(formArray.at(i), riderStateArray[i], $event, i,$event)" >
                    </mis-dropdown>
                  </div>
                  <app-select [showClear]="!field.config.mandatory" *ngIf="field.elementKey == 'costCenter'"
                    [config]="field.config" [type]="'dropdownAndSearch'"
                    [formControl]="rider.get(field.elementKey)" [options]="this.costCenterNames"
                    [selectStyleApplied]="selectStyleApplied" [editableCostCenter]="editableCostCenter" [ngClass]="{'disableDropdown':field.config?.disable &&  rider.get(field.elementKey).value}">
                  </app-select>
                  <app-select [showClear]="!field.config.mandatory" *ngIf="['department','businessUnit'].includes(field.elementKey)"
                    [config]="field.config" [type]="'dropdownAndSearch'" [formControl]="rider.get(field.elementKey)"
                    [options]="this.departmentListName" [selectStyleApplied]="selectStyleApplied" [ngClass]="{'disableDropdown':field.config?.disable &&  rider.get(field.elementKey).value}">
                  </app-select>
                  <app-phone-input-component
                  *ngIf="field.elementKey =='alternateMobile'"
                  [config]="field.config"
                  [hidden]="rider.get(field.elementKey).isHidden"
                  [formControls]="rider.get(field.elementKey)"
                  [inputFormControlNumber]="rider.get('mobile')"
                  [inputFormControlCode]="rider.get('phoneCode')"
                  (onCodeChange)="onCodeChange($event,rider.get('phoneCode'))"
                  [dropdownWidth]="'6vw'"
                  ></app-phone-input-component>
                  <div class="mobile-no" *ngIf="field.elementKey =='alternateMobile' && rider.get(field.elementKey).isHidden">
                 {{rider.get('phoneCode')?.value + " " + (rider.get('mobile')?.value | formatPhoneNumber : rider.value)}}
                  </div>
                    <app-phone-input-component
                    *ngIf="field.elementKey =='alternatePhoneCode'"
                    [config]="field.config"
                    [formControls]="rider.get(field.elementKey)"
                    [inputFormControlNumber]="rider.get('alternateMobile')"
                    [inputFormControlCode]="rider.get('alternatePhoneCode')"
                    (onCodeChange)="onCodeChange($event,rider.get('alternatePhoneCode'))"
                    [dropdownWidth]="'6vw'"
                    ></app-phone-input-component>
                  </ng-container>
              </td>

              <td class="editable-row-static-content" [ngClass]="field.elementKey"
                *ngIf="!editRiderInfo && rider.get(field.elementKey).disabled && !['mobile','phoneCode','alternatePhoneCode'].includes(field.elementKey)">
                {{ ['mobile','alternateMobile'].includes(field.elementKey) ? (rider.get(field.elementKey)?.value | formatPhoneNumber : rider.value):  rider.get(field.elementKey)?.value }}
              </td>
              <td class="editable-row-static-content" *ngIf="field.elementKey === 'payer' 
                && field.config.visibility.visible
                && paymentType === 'Bill To User'">
                <app-radio-button *ngIf="rider.get('riderType')?.value !== 'Guest'" class="option-radio"
                  [option]="payeeOptions[i]" [selectedValue]="selectedPayer" (changeCallback)="onRiderChange($event)"
                  name="payerSelect">
                </app-radio-button>
              </td>
            </ng-container>
          </ng-container>
          <td><button mat-icon-button (click)="onEditClick(i)" class="edit-rider-btn">
              <mat-icon>edit</mat-icon>
            </button></td>
        <td class="editable-row-button rider-row-default">
            <button mat-icon-button *ngIf="rider.get('isNew') || !editModeControlHide['ClearRiderRow']"
              (click)="onDeleteClick(i)" [ngClass]="{'disableDropdown': commonService.workflowConfig?.blockSelfDeletion && rider.get('riderTypeId').value=='Self' }">
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
  </div>
  <div class=" mt-16">
    <ng-container *ngIf="searchConfig">
      <app-search *ngIf="checkVisibility(searchConfig.config) && !editModeControlHide[searchConfig.config?.elementKey]"
        [customStyle]="'rider-search'" type="searchAndSelect" placeholder="Search to add employee"
        [fetchAsyncOptions]="riderSearch" [getCustomOptionValue]="getUserOptionValue"
        [getCustomOptionLabel]="getUserOptionLabel" (changeCallback)="onRiderSelect($event)" (addRiderCallback)="addEmptyRiderForm()" [configObject]="addRiderConfig"
        [riderLimitReached]="riderLimitReached"></app-search>
    </ng-container>
    <div *ngIf="duplicateRiderMsg" class="duplicateMsg error-msg">{{duplicateRiderMsg}}</div>
  </div>
  <div *ngIf="riderLimit && riderLimit>0" class=" fs-12 geoaraea-label displayFlex align-item-center">
     <span class="mr-8"><img src="assets/ic-action-info-24-grey.svg" alt=""></span> You can add upto {{riderLimit}} passenger(s)
    </div>
</div>